import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import checkValidity from '../../utils/validation';
import { changePassword } from '../../utils/sideEffects';
import { homeUrl } from '../../constants/appUrls';
import AuthContext from '../../contexts/AuthContext';

import Button from '../../components/UI/Button';
import Input from '../../components/UI/Input';
import Spinner from '../../components/UI/Spinner';

class ChangePassword extends Component {
    static contextType = AuthContext;

    state = {
        changePasswordForm: {
            oldPassword: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'Old Password',
                },
                value: '',
                validation: {
                    isPassword: true,
                    minLength: 8,
                    required: true,
                },
                isValid: false,
                touched: false,
            },
            password: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'Password',
                    autoComplete: '',
                },
                value: '',
                validation: {
                    isPassword: true,
                    minLength: 8,
                    required: true,
                },
                isValid: false,
                touched: false,
            },
            confirmPassword: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'Confirm Password',
                    autoComplete: '',
                },
                value: '',
                validation: {
                    isPassword: true,
                    minLength: 8,
                    required: true,
                },
                isValid: false,
                touched: false,
            },
        },
        isFormValid: false,
        isLoading: false,
        error: null,
    }

    formSubmitHandler = async event => {
        this.setState({ isLoading: true });
        event.preventDefault();
        let formData = {};
        for (let key in this.state.changePasswordForm) {
            formData = {
                ...formData,
                [key]: this.state.changePasswordForm[key].value
            }
        }
        const result = await changePassword(formData);
        if (result.status !== 201) {
            this.setState({ error: result.data, isLoading: false });
        } else {
            this.props.history.replace(homeUrl);
        }
    }

    inputChangeHandler = (key, event) => {
        const form = { ...this.state.changePasswordForm };
        const element = { ...form[key] };
        element.value = event.target.value;
        element.isValid = checkValidity(event.target.value, element.validation);
        element.touched = true;
        form[key] = element;
        let isFormValid = true;
        for (key in form) {
            isFormValid = form[key].isValid && isFormValid;
        }
        this.setState({ changePasswordForm: form, isFormValid: isFormValid });
    }

    render() {

        const formElements = [];
        for (let key in this.state.changePasswordForm) {
            formElements.push({
                id: key,
                config: this.state.changePasswordForm[key]
            })
        }

        let form = <form className="form" onSubmit={this.formSubmitHandler}>
            <h1 className="form__title">Change Password</h1>
            {this.state.error && <p className="form__error">{this.state.error.status}: {this.state.error.message}</p>}
            {formElements.map(element => {
                return <Input
                    key={element.id}
                    elementType={element.config.elementType}
                    value={element.config.value}
                    isValid={element.config.isValid}
                    touched={element.config.touched}
                    elementConfig={element.config.elementConfig}
                    changed={(event) => { this.inputChangeHandler(element.id, event) }} />
            })}
            <Button className="btn form__btn" type="submit">Change</Button>
        </form>;

        if (this.state.isLoading) {
            form = <Spinner />
        }

        return form;
    }
}

export default withRouter(ChangePassword);